import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=25ae811a&scoped=true&"
import script from "./alert.ts?vue&type=script&lang=ts&"
export * from "./alert.ts?vue&type=script&lang=ts&"
import style0 from "./alert.scss?vue&type=style&index=0&id=25ae811a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ae811a",
  null
  
)

export default component.exports